<template>
	<div class="im-service-dialogue-panel">
		<section class="im-service-panel-width im-service-dialogue-panel__main">
			<div class="resize-bar"></div>
			 <div class="resize-line"></div>
			 <div class="resize-save">
				<!-- 聊天面板容器 -->
				<chatHeader :source="index_infos"/>
				<div class="im-service-dialogue-panel__box" v-if="index_infos && Object.keys(index_infos).length > 0">
					<virtual-list class="list-infinite scroll-touch" id="majorelChatPanel"
					  :data-key="'msg_id'"
					  :data-sources="lists"
					  :data-component="itemComponent"
					  :item-class="'list-item-infinite'"
					   v-on:scroll="panelScroll"
					  v-on:totop="onScrollToTop">
					<div slot="header" class="loading-toobar">
						<el-button @click="toMore()" type="text" :disabled="!isMore" :loading="loading">{{loading ? '加载中...' : isMore ? '加载更多' : '没有更多数据咯'}}</el-button>
					</div>
					</virtual-list>
					<!-- 置底按钮 -->
					<transition name="el-fade-in-linear">
					  <div
					    v-show="tipsBoard"
					    class="tips-board pointer"
					    @click="toScrollBottom">
							<span>回到底部</span>
					  </div>
					</transition>
					<!-- 新消息气泡 -->
					<div v-show="tipsBoard && unreadMessage.num"
						class="talk-bubble"
						@click="toScrollBottom">
					  <i class="el-icon-chat-dot-round" />
					  <span>新消息({{ unreadMessage.num }}条)</span>
					  <span>
					    【{{unreadMessage.content}}】
					  </span>
					</div>
					<!-- 聊天预览 -->
					<p class="talk-preview" v-show="preview_text.session_id == index_name && getImServiceAuth('1005')">
						{{$$(preview_text,'msg') ? '对方正在输入中：': ''}}{{decodeURI(preview_text.msg)}}
					</p>
				</div>
				<el-empty v-else style="height: 100%;" image="https://assistant-cdn.porsche-scrm-engagement.com/static/images/chat.png"></el-empty>
				<!-- 页脚 -->
				<div class="im-service-dialogue-panel__footer">
					<Editor ref="editorViewer" @handleEvent="handleEvent" @keyboard-event="onKeyboardEvent" @send="submitSendMesage" :historyBtnDisabled="historyAuth.disabled"/>
				</div>
				<!-- 聊天历史 -->
				<HistoryPanel v-if="historyAuth.show" @onClose="historyAuth.show = false"/>
			</div>    
		</section>
		<section class="im-service-dialogue-panel__control">
			<template v-if="customerinfo_panels.length > 0">
				<!-- 客户信息 -->
				<section class="customer-box">
					<el-tabs :value="index_name" type="card" class="el-tabs__customer">
					  <el-tab-pane
					    v-for="(item, index) in customerinfo_panels"
					    :key="item.session_id"
					    :name="item.session_id" >
					    <CustomerInfo sourceType="im" :customerId="item.customerId" :tuId="item.tuId"/>
					   </el-tab-pane>
					</el-tabs>
				</section>
				
			</template>
			<template v-if="index_name">
				<!-- 快捷话术 -->
				<FastwordPannel
					v-model="fastwordViewer.isShow"
					@confirm="confirmFastwords"
				/>
				<!-- 客服转接 -->
				<TransferPannel 
					v-model="transferViewer.isShow"
				/>
			</template>
		</section>
		


		
	</div>
</template>

<script>
	import { chatHeader } from '../common';
	import chatItem from './chatItem';
	import Editor from  './editor/editor';
	// import TransformPanle from './transform';
	import HistoryPanel from './history';
	import FastwordPannel from './control/fastWord';
	import TransferPannel from './control/transfer';
	import CustomerInfo from '@/components/CustomerInfo';
	import { mapState } from 'vuex';
	import { getSort, getMutipSort } from '@/utils/functions';
	import { imChatService } from '@/utils/mixins';
	import { getImServiceAuth, uniqueArray } from '@/utils/imService';
	export default {
		mixins:[imChatService],
		components:{
			chatHeader,
			Editor,
			HistoryPanel,
			CustomerInfo,
			FastwordPannel,
			TransferPannel
		},
		data(){
			return {
				itemComponent: chatItem,
				isMore:false,
				loading:false,
				listQuery:{
					pageNum:1,
					pageSize:10,
					customerId:'',
					sessionId:''
				},
				// 置底按钮是否显示
				tipsBoard: false,
				// 历史记录按钮权限
				historyAuth: {
				  disabled: true,
				  show:false
				},
				fastwordViewer:{
					isShow:false,
				},
				transferViewer:{
					isShow:false
				}
			}
		},
		computed: {
			...mapState({
				index_name:state => state.imChatService.index_name,
				index_infos:state => state.imChatService.index_infos,
				lists:state => state.imChatService.records,
				unreadMessage: state => state.imChatService.unreadMessage,
				preview_text:state => state.imChatService.preview_text,
				customerinfo_panels:state => state.imChatService.customerinfo_panels
			})
		},
		watch:{
			'index_name':{
				handler(val){
					if(!val) return this.resetControlPannel();
					this.$store.commit('imChatService/SET_DIALOGUE',[]);
					this.listQuery.pageNum = 1;
					this.resetControlPannel();
					this.initData();
					this.getHistoryBtnAuth();
					this.getCatchPanels();
				},
				deep:true
			}
		},
		methods:{
			getImServiceAuth,
			// 右侧快捷话术事件
			confirmFastwords(source){
				this.$refs.editorViewer.confirmKeyword(source);
			},
			// 右侧客户信息页面数据处理
			getCatchPanels(){
				if(!this.index_name) return;
				let index = this.customerinfo_panels.findIndex(item =>  item.session_id == this.index_name);
				if(index == -1){
					this.$store.commit('imChatService/PUSH_CUSTOMERINFO_PANELS',{
						customerId:this.index_infos.customerInfo.customerId,
						tuId:this.index_infos.incidentId,
						session_id:this.index_name
					});
				}	
			},
			// 发送面板按钮事件
			handleEvent(source){
				if(source.type == 'history'){
					this.historyAuth.show = true;
					return;
				}
				this.resetControlPannel();
				if(source.type == 'fastword'){
					this.fastwordViewer.isShow = true;
				}
				if(source.type == 'transfer'){
					this.transferViewer.isShow = true;
				}
			},
			// 编辑消息
			onKeyboardEvent(text){
				this.$store.commit('imChatService/UPDATE_TALK_ITEM', {
				  session_id: this.index_name,
				  draft_text: text,
				});
			},
			submitSendMesage(content){
				this.sendMessagetoApi({
					brand:this.index_infos.brand,
					channel:this.index_infos.channel,
					session_id:this.index_name,
					skillGroup:this.index_infos.skillGroup,
					type:'text',
					msg:content
				}).then(() => {})
			},
			onScrollToTop(){
				if(this.isMore){
					this.toMore()
				}
			},
			toMore(){
				this.listQuery.pageNum++;
				if(this.listQuery.pageNum > this.totalSize) {
					this.isMore = false;
					this.listQuery.pageNum = 1;
				}else {
					this.isMore = true;
				}
				this.getMoreData()
				
			},
			getMoreData(params){
				this.loading = true;
				this.$api.getImServiceEndedChat(this.listQuery).then(res => {
					this.loading = false
					if(res.errcode != 0)  return;
					this.isMore = res.pages > this.listQuery.pageNum;
					let results = res.list.length > 0 ?  res.list.concat(this.lists) : res.list;
					this.$store.commit('imChatService/SET_DIALOGUE',results);
					this.totalSize = res.pages;
					
				})
			},
			initData(){
				if(!this.index_infos?.sender_id) return;
				this.loading = true;
				this.listQuery.customerId = this.index_infos.sender_id;
				this.listQuery.sessionId = this.index_name;
				this.listQuery.pageNum = 1;
				this.$api.getImServiceEndedChat(this.listQuery).then(res => {
					this.loading = false
					if(res.errcode != 0)  return;
					this.isMore = res.pages > this.listQuery.pageNum;
					this.totalSize = res.pages;
					this.$iMLocalforage.getItem(this.listQuery.sessionId).then(value => {
						if(value && value.length > 0){
							let catch_lists = res.list.concat(value);
							catch_lists = uniqueArray(catch_lists,'msg_id');
							catch_lists = catch_lists.sort(getMutipSort([
							  getSort((a, b) => a.sendtime < b.sendtime),
							]));
							this.$store.commit('imChatService/SET_DIALOGUE',catch_lists);
							return;
						}
						let results = res.list;
						results = results.sort(getMutipSort([
						  getSort((a, b) => a.sendtime < b.sendtime),
						]));
						this.$store.commit('imChatService/SET_DIALOGUE',results);
					})
					this.$nextTick(() => {
					  let el = document.getElementById('majorelChatPanel')
					  	el.scrollTop = el.scrollHeight
					})
				})
			},
			toScrollBottom(){
				let el = document.getElementById('majorelChatPanel');
				el.scrollTop = el.scrollHeight
			},
			panelScroll(e){
				if(e.target.scrollTop == 0) return;
				const height = e.target.scrollTop + e.target.clientHeight + 5;
				this.tipsBoard = height < e.target.scrollHeight;
				 if (this.tipsBoard == false && this.unreadMessage.num > 0) {
						this.$store.commit('imChatService/CLEAR_TLAK_UNREAD_MESSAGE')
				   }
			},
			/* 历史记录按钮权限 */
			async getHistoryBtnAuth(){
				if(!this.index_name) return;
				await this.$api.judgeImserviceToShowHistoryBtn(this.index_name).then(res => {
					if(res.errcode != 0);
					this.historyAuth.disabled = res.data;
				})
			},
			/* 初始化右侧面板 */
			resetControlPannel(){
				this.fastwordViewer.isShow = false;
				this.transferViewer.isShow = false;
				this.historyAuth.show = false;
			}
		},
		mounted() {
			this.$store.commit('imChatService/SET_DIALOGUE',[]);
			this.resetControlPannel();
			this.initData();
			this.getHistoryBtnAuth();
			this.getCatchPanels();
		},
		destroyed() {
			this.$store.commit('imChatService/CLEAR_CUSTOMERINFO_PANELS');
		}
	}
</script>

<style lang="scss" scoped>
	.im-service-dialogue-panel {
		width: 100%;
		height: 100%;
		display: flex;
		position: relative;
		
		&__main {
			position: relative;
			height: calc(100vh - 94px);
			.resize-save {
			    position: absolute;
			    top: 0; 
				right: 5px;
				bottom: 0; 
				left: 0;
			    // padding: 16px;
			    overflow-x: hidden;
			}
			.resize-bar {
			    min-width: 500px;
				max-width: calc(100vw - 600px - 294px - 210px);
				height: calc(100vh - 94px);
			    resize: horizontal;
			    cursor: ew-resize;
			    cursor: col-resize;
			    opacity: 0;
			    overflow: scroll;
			}
			/* 拖拽线 */
			.resize-line {
			    position: absolute;
			    right: 0;
				top: 0;
				bottom: 0;
			    border-right: 1px solid #d8d8d8;
			    pointer-events: none;
			}
			.resize-bar:hover ~ .resize-line,
			.resize-bar:active ~ .resize-line {
			    border-left: 1px dashed #337EFF;
			}
			.resize-bar::-webkit-scrollbar {
				min-width: 500px;
				height: calc(100vh - 94px);
			}
		}
		&__control {
			flex: 1;
			height: 100%;
			background-color: #fff;
			padding: 0;
			position: relative;
			overflow: hidden;
			display: flex;
			.el-tabs__customer {
				::v-deep {
					> .el-tabs__header {
							display: none;
						}
				}
			}
			.customer-box {
				height: 100%;
				overflow-y: auto;
			}
			
		}
		
		&__box {
			height: calc(100% - 270px - 55px);
			overflow: hidden;
			position: relative;
			.scroll-touch {
				height: 100%;
				overflow: auto;
				padding: 0 20px 20px 20px;
			}
			.loading-toobar {
				display: flex;
				justify-content: center;
			}
			.tips-board {
			  display: flex;
			  justify-content: center;
			  align-items: center;
			  position: absolute;
			  left: 0;
			  right: 0;
			  margin: 0 auto;
			  bottom: 20px;
			  height: 30px;
			  width: 100px;
			  border-radius: 20px;
			  font-size: 12px;
			  background-color: #fff;
			  box-shadow: 0 2.5px 10px 0 rgba(31, 35, 41, 0.1);
			  color: #1f2329;
			  z-index: 99;
			
			  span {
			    margin-left: 5px;
			    margin-top: -2px;
			  }
			}
			
			.talk-bubble {
			  position: absolute;
			  left: 0px;
			  bottom: 20px;
			  max-width: 300px;
			  height: 40px;
			  line-height: 40px;
			  border-radius: 0 20px 20px 0;
			  overflow: hidden;
			  text-overflow: ellipsis;
			  white-space: nowrap;
			  color: white;
			  padding: 0 15px 0 30px;
			  font-size: 13px;
			  background: #409eff;
			  z-index: 99;
			
			  i {
			    font-size: 22px;
			    position: absolute;
			    left: 5px;
			    top: 9px;
			  }
			}
			.talk-preview {
				position: absolute;
				bottom: 0;
				background-color: #fff;
				width: 100%;
				height: 30px;
				line-height: 30px;
				color: #838A9D;
				text-align: left;
				font-size: 12px;
				padding-left: 20px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			
		}
		
		&__footer {
			height: 270px;
			box-sizing: border-box;
			border-top: 1px solid #d8d8d8;
			position: relative;
		}
	}
</style>